import styled from "styled-components";
import {
  getErrorMessage,
  getErrorDescription,
} from "../utils/transactionFormatter";

const Banner = styled.div`
  background-color: #fee2e2;
  border: 1px solid #fca5a5;
  border-radius: 8px;
  padding: 16px 20px;
  margin-bottom: 20px;

  .error-header {
    margin-bottom: 8px;

    h3 {
      color: #dc2626;
      margin: 0;
      font-size: 18px;
      font-weight: 600;
    }
  }

  .error-message {
    color: #991b1b;
    font-weight: 500;
    margin-bottom: 4px;
  }

  .error-description {
    color: #7f1d1d;
    font-size: 14px;
    line-height: 1.5;
  }

  .error-note {
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px solid #fca5a5;
    color: #7f1d1d;
    font-size: 13px;
    font-style: italic;
  }
`;

export default function ErrorBanner({ extrinsic }) {
  if (!extrinsic || extrinsic.isSuccess !== false) {
    return null;
  }

  const errorMessage = getErrorMessage(extrinsic.error);
  const errorDescription = getErrorDescription(extrinsic.error);

  return (
    <Banner>
      <div className="error-header">
        <h3>Transaction Failed</h3>
      </div>

      <div className="error-message">Error: {errorMessage}</div>

      {errorDescription && (
        <div className="error-description">{errorDescription}</div>
      )}

      <div className="error-note">
        * Transaction was rejected but still processed
      </div>
    </Banner>
  );
}
